export default __webpack_public_path__ + "media/images/favicon/cube_light_icon-678bcce4f1f03e3dd24b1f531fd84fcb.png";